import EditMissionModel from '@/Classes/800/EditMissionCall.js';
import Vue from 'vue';
import CancelReasonMixin from '@/Mixins/BaseInformation/CancelReasonMixin';
import TitleHelper from '@/Helpers/pageTitle.helper';
export default {
  data() {
    return {
      editInfoTabClass: 'menu-top-items active-tab',
      timeTabClass: 'menu-top-items',
      doctorInsideTabClass: 'menu-top-items',
      moreTabClass: 'menu-top-items',
      otherOrganTabClass: 'menu-top-items',
      noteTabClass: 'menu-top-items',
      addressTabClass: 'menu-top-items',
      disabelConfirm: false,
      confimType: '',
      editMissionSelectedCancleReason: null,
      editTab: 'edit',
      editMissionTenNineteenNote: '',
      listOfMissionLakeCodeStation: [],
      hasHospitalFlag: null,
      hasStatusFlag: null,
      tenNineteenModal: false,
      listOfMissionCallerIds: [],
      selectedMissionLakeCode: null,
      save_dispatchCurrentState: null,
      save_hospitalId: null,
      missionInformation: new EditMissionModel.EditMission(
        null,
        '',
        null,
        [],
        null,
        '',
        null,
        false,
        false,
        false,
        false,
        null,
        false,
        '',
        [],
        null,
      ),
      cancelHospitalModal: false,
      isHospitalChangeFlag: false,
      //time
      missionTimes: '',
      stateDataTableItems: [],
      stateDataTableHeader: [],
      missionInformationTagList: [],
      passedTimeFromCallInterval: null,
      passedTimeFromDispatchInterval: null,
      //note
      noteText: '',
      noteList: [],
      disabelNoteConfirm: false,
      //address
      addressDataTableHeader: [],
      locationConfiramtionTableHeader: [
        {
          text: 'تاریخ',
          value: 'date',
          align: 'center',
          sortable: false,
        },
        {
          text: 'طول جغرافیایی',
          value: 'longitude',
          align: 'center',
          sortable: false,
        },
        {
          text: 'عرض جغرافیایی',
          value: 'latitude',
          align: 'center',
          sortable: false,
        },
        {
          text: 'کاربر',
          value: 'fullName',
          align: 'center',
          sortable: false,
        },
      ],
      addressDataTableItems: [],
      phoneOnlineLocationInterval: null,
      mapSingleMovingIconInterval: null,
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      //doctor
      allDoctorOrders: [],
      //admission
      admissionDataTableHeader: [],
      missionAttachDetailDataTableHeader: [],
      admissionDataTableItems: [],
      missionAttachDetailDataTableItems: [],
      selectedOtherOrgan: null,
      polyline: {
        latlngs: [],
        color: '#49454F',
      },
      pathsList: [],
      latLngsPathList: [],
      wasDispatchState1019: false,
    };
  },
  mixins: [CancelReasonMixin, TitleHelper],
  methods: {
    showConfirmDialog800Function: function () {
      if (this.confimType == 'time') {
        this.$refs.confirm.title = 'ثبت زمان';
        this.$refs.confirm.text = 'آیا از ثبت زمان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      if (this.confimType == 'lastState') {
        this.$refs.confirm.title = 'ارسال مجدد آخرین وضعیت';
        this.$refs.confirm.text = 'آیا از ارسال مجدد آخرین وضعیت اطمینان دارید؟ ';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirm800Function: function () {
      if (this.confimType == 'time') {
        this.disabelConfirm = true;
        this.SetTimeBy800();
      }
      if (this.confimType == 'lastState') {
        this.disabelConfirm = true;
        this.missionResendLastStateFunction(this.missionPhoneId);
      }
    },
    confirmDialogCancel800Function: function () {
      if (this.confimType == 'time' || this.confimType == 'lastState') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },

    //10-19
    showTenNineteenModal: function () {
      this.getListOfCancelReasons();
      this.tenNineteenModal = true;
    },
    changeDispatchCurrentState: function (item) {
      if (item === '10-19') {
        this.showTenNineteenModal();
        this.missionInformation.allow1019 = true;
      } else {
        this.missionInformation.allow1019 = false;
      }
    },
    setCancelReasonFor800MissionFunction: function () {
      if (this.editMissionTenNineteenNote) {
        this.tenNineteenModal = false;
      } else {
        this.showErrorAlert('علت 10-19 اجباری است');
      }
    },
    onAccept1019: function () {
      if (this.missionInformation.allow1019) {
        this.showTenNineteenModal();
        this.missionInformation.allow1019 = true;
      } else if (!this.missionInformation.allow1019) {
        this.missionInformation.allow1019 = false;
      }
    },
    cancelSetCancleReaonFor800Mission: function () {
      this.missionInformation.dispatchCurrentState = this.save_dispatchCurrentState
      this.missionInformation.allow1019 = false;
      this.editMissionSelectedCancleReason = null;
      this.editMissionTenNineteenNote = '';
      this.tenNineteenModal = false;
    },
    setCancelReasonNote: function () {
      this.editMissionTenNineteenNote = this.editMissionSelectedCancleReason;
    },
    changeTab: function (title) {
      if (title == 'edit') {
        this.editInfoTabClass = 'menu-top-items active-tab';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.otherOrganTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        this.selectedOtherOrgan = null;
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.editTab = 'edit';
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'time') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items active-tab';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.otherOrganTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        this.selectedOtherOrgan = null;
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
        this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        this.editTab = 'time';
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'doctor') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items active-tab';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.otherOrganTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        this.selectedOtherOrgan = null;
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.editTab = 'doctor';
        this.getAllPatientDoctorDetailFunction(this.missionPhoneId);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'moreInfo') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items active-tab';
        this.noteTabClass = 'menu-top-items';
        this.otherOrganTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        this.selectedOtherOrgan = null;
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.editTab = 'moreInfo';
        //this.getMissionPhoneOtherOrganizationFunction(this.missionPhoneId);
        this.getMissionPhoneAdmissionHistoryFunction(this.missionPhoneId);
        this.getMissionAttachListFunction(this.missionId);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'note') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items active-tab';
        this.otherOrganTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        this.selectedOtherOrgan = null;
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.noteText = '';
        this.getAllMissionNoteFunction(this.missionId, this.missionPhoneId);
        this.editTab = 'note';
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'address') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.otherOrganTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items active-tab';
        this.callTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.getAllMissionAddressLogFunction(this.missionId);
        this.getPhoneOnlineLocationFunction(this.phoneId);
        this.selectedOtherOrgan = null;
        this.mapSingleMovingIconInterval = setInterval(() => {
          this.getPhoneOnlineLocationFunction(this.phoneId);
        }, 4000);
        this.editTab = 'address';
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'otherOrgan') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.otherOrganTabClass = 'menu-top-items active-tab';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.editTab = 'otherOrgan';
        this.allMissionOtherOrganizationRequests = [];
        this.allMissionOtherOrganizationInforms = [];
        this.getAllMissionOtherOrganizationRequestsFor800TopListFunction(this.missionId);
        this.getListOfOtherOrganizationsForOther();
        this.getAllMissionOtherOrganizationInformsFor800TopListFunction(this.missionId);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'calls') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.otherOrganTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.callTabClass = 'menu-top-items active-tab';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.editTab = 'calls';
        this.getMissionCallsfunction(this.missionId);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      }
    },
    addMissionLakeCode: function () {
      let flag = false;
      if (this.listOfMissionLakeCodeStation.length > 0) {
        for (let i = 0; i < this.listOfMissionLakeCodeStation.length; i++) {
          if (this.listOfMissionLakeCodeStation[i].id == this.selectedMissionLakeCode.id) {
            flag = true;
          }
        }
      }
      if (flag == false) {
        this.listOfMissionLakeCodeStation.push({
          title: this.selectedMissionLakeCode.title,
          titleCode: this.selectedMissionLakeCode.titleCode,
          id: this.selectedMissionLakeCode.id,
        });
        this.selectedMissionLakeCode = null;
      } else {
        this.snackText = 'منطقه قبلا اضافه شده است';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      }
    },
    removeMissionLakeCode: function (id) {
      for (let i = 0; i < this.listOfMissionLakeCodeStation.length; i++) {
        if (this.listOfMissionLakeCodeStation[i].id == id) {
          this.listOfMissionLakeCodeStation.splice(i, 1);
        }
      }
    },
    closeMissionEditModal: function () {
      this.changeToOldTitle();
      this.listOfMissionLakeCodeStation = [];
      this.missionInformationTagList = [];
      this.mainPationtPosition = {};
      this.missionInformation = new EditMissionModel.EditMission(
        null,
        '',
        null,
        [],
        null,
        '',
        null,
        false,
        false,
        false,
        false,
        null,
        false,
        '',
        [],
        null,
      );
      this.polyline = {
        latlngs: [],
        color: '#49454F',
      };
      try {
        this.$root.$refs?.currentMission800View?.closeEditModal();
      } catch (error) { console.log(error); }
      try {
        this.$root.$refs?.Mission800View?.closeEditModal();
      } catch (error) { console.log(error); }
      try {
        this.$root.$refs?.MissionAdmissionView?.closeEditModal();
      } catch (error) { console.log(error); }
      try {
        this.$root.$refs.Home.playerHome = false;
      } catch (error) { console.log(error); }
    },
    //cancel hospital
    hospitalChange: function () {
      if (this.hasHospitalFlag) {
        this.isHospitalChangeFlag = true;
        this.cancelHospitalModal = true;
      }
    },
    showCancelHospitalModal: function () {
      if (this.hasHospitalFlag) {
        this.cancelHospitalModal = true;
        this.isHospitalChangeFlag = false;
      }
    },
    setCancelHospital: function () {
      if (this.isHospitalChangeFlag == false) {
        this.missionInformation.hospitalId = null;
      }
      this.isHospitalChangeFlag = false;
      this.cancelHospitalModal = false;
    },
    cancelSetCancelHospital: function () {
      this.missionInformation.hospitalId = this.save_hospitalId
      this.isHospitalChangeFlag = false;
      this.missionInformation.hospitalCancelReason = '';
      this.cancelHospitalModal = false;
    },
    //time tab
    readyTimeData: function (fenceTimes, data) {
      let fenceMoveFromStationTime = '-';
      let fenceArriveToLocationTime = '-';
      let fenceMoveFromLocationTime = '-';
      let fenceArriveToHospitalTime = '-';
      let fenceFinishTime = '-';
      let fenceArriveToStationTime = '-';
      if (fenceTimes) {
        if (fenceTimes.moveFromStationTime) {
          fenceMoveFromStationTime = Vue.moment(fenceTimes.moveFromStationTime).format('HH:mm:ss');
        }
        if (fenceTimes.arriveToLocationTime) {
          fenceArriveToLocationTime = Vue.moment(fenceTimes.arriveToLocationTime).format(
            'HH:mm:ss',
          );
        }
        if (fenceTimes.moveFromLocationTime) {
          fenceMoveFromLocationTime = Vue.moment(fenceTimes.moveFromLocationTime).format(
            'HH:mm:ss',
          );
        }
        if (fenceTimes.arriveToHospitalTime) {
          fenceArriveToHospitalTime = Vue.moment(fenceTimes.arriveToHospitalTime).format(
            'HH:mm:ss',
          );
        }
        if (fenceTimes.finishTime) {
          fenceFinishTime = Vue.moment(fenceTimes.finishTime).format('HH:mm:ss');
        }
        if (fenceTimes.arriveToStationTime) {
          fenceArriveToStationTime = Vue.moment(fenceTimes.arriveToStationTime).format('HH:mm:ss');
        }
      }
      let moveFromStationPer = false;
      let arriveToLocationPer = false;
      let moveFromLocationPer = false;
      let arriveToHospitalPer = false;
      let patientDeliveryPer = false;
      let finishPer = false;
      let arriveToStationPer = false;
      this.missionTimes = [];
      let finishTime = '-';
      let arriveToStationTime = '-';
      let patientDeliveryTime = '-';
      let arriveToHospitalTime = '-';
      let moveFromLocationTime = '-';
      let arriveToLocationTime = '-';
      let moveFromStationTime = '-';
      let deliveryTime = '-';
      let pickupTime = '-';
      let ringTime = '-';
      let passedFromCallTime = '-';
      let passedFromDispatchTime = '-';
      if (data.finishTime) {
        finishTime = Vue.moment(data.finishTime).format('HH:mm:ss');
      } else {
        finishPer = true;
      }
      if (data.arriveToStationTime) {
        arriveToStationTime = Vue.moment(data.arriveToStationTime).format('HH:mm:ss');
      } else {
        arriveToStationPer = true;
      }
      if (data.patientDeliveryTime) {
        patientDeliveryTime = Vue.moment(data.patientDeliveryTime).format('HH:mm:ss');
      } else {
        patientDeliveryPer = true;
      }
      if (data.arriveToHospitalTime) {
        arriveToHospitalTime = Vue.moment(data.arriveToHospitalTime).format('HH:mm:ss');
      } else {
        arriveToHospitalPer = true;
      }
      if (data.moveFromLocationTime) {
        moveFromLocationTime = Vue.moment(data.moveFromLocationTime).format('HH:mm:ss');
      } else {
        moveFromLocationPer = true;
      }
      if (data.arriveToLocationTime) {
        arriveToLocationTime = Vue.moment(data.arriveToLocationTime).format('HH:mm:ss');
      } else {
        arriveToLocationPer = true;
      }
      if (data.moveFromStationTime) {
        moveFromStationTime = Vue.moment(data.moveFromStationTime).format('HH:mm:ss');
      } else {
        moveFromStationPer = true;
      }
      if (data.deliveryTime) {
        deliveryTime = Vue.moment(data.deliveryTime).format('HH:mm:ss');
      }
      if (data.pickupTime) {
        pickupTime = Vue.moment(data.pickupTime).format('HH:mm:ss');
      }
      if (data.ringTime) {
        ringTime = Vue.moment(data.ringTime).format('HH:mm:ss');
      }
      this.missionTimes.push(
        {
          title: 'زمان تماس',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: ringTime,
          id: 1,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'زمان پاسخ',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: pickupTime,
          id: 2,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'زمان گذشته از تماس',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: passedFromCallTime,
          id: 3,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'زمان گذشته از ابلاغ',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: passedFromDispatchTime,
          id: 4,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'دریافت ماموریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: deliveryTime,
          id: 5,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'حرکت از پایگاه',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: moveFromStationTime,
          id: 6,
          size: 3,
          per: moveFromStationPer,
          perKey: 'moveFromStation',
          secondText: fenceMoveFromStationTime,
        },
        {
          title: 'رسیدن به فوریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToLocationTime,
          id: 7,
          size: 3,
          per: arriveToLocationPer,
          perKey: 'arriveToLocation',
          secondText: fenceArriveToLocationTime,
        },
        {
          title: 'حرکت از فوریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: moveFromLocationTime,
          id: 8,
          size: 3,
          per: moveFromLocationPer,
          perKey: 'moveFromLocation',
          secondText: fenceMoveFromLocationTime,
        },
        {
          title: 'رسیدن به درمانی',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToHospitalTime,
          id: 9,
          size: 3,
          per: arriveToHospitalPer,
          perKey: 'arriveToHospital',
          secondText: fenceArriveToHospitalTime,
        },
        {
          title: 'تحویل به درمانی',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: patientDeliveryTime,
          id: 10,
          size: 3,
          per: patientDeliveryPer,
          perKey: 'patientDelivery',
          secondText: '',
        },
        {
          title: 'پایان ماموریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: finishTime,
          id: 13,
          size: 3,
          per: finishPer,
          perKey: 'finish',
          secondText: fenceFinishTime,
        },
        {
          title: 'رسیدن به پایگاه',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToStationTime,
          id: 12,
          size: 3,
          per: arriveToStationPer,
          perKey: 'arriveToStation',
          secondText: fenceArriveToStationTime,
        },

      );
      if (data.ringTime) {
        let date1 = new Date(data.currentTime);
        let date2 = new Date(data.ringTime);
        let dd = date1.getTime() - date2.getTime();
        this.passedTimeFromCallInterval = setInterval(() => {
          dd = dd + 1000;
          this.missionTimes[2].text = this.msToTime(dd);
        }, 1000);
      }
      if (data.dispatchTime) {
        let date1 = new Date(data.currentTime);
        let date2 = new Date(data.dispatchTime);
        let dd = date1.getTime() - date2.getTime();
        this.passedTimeFromDispatchInterval = setInterval(() => {
          dd = dd + 1000;
          this.missionTimes[3].text = this.msToTime(dd);
        }, 1000);
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;

      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    readyStateData: function (data) {
      this.stateDataTableHeader = [
        { text: 'وضعیت', value: 'state', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'توضیحات', value: 'note', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.stateDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.stateDataTableItems.push({
          state: data[i].state ? data[i].state : '-',
          date: date,
          note: data[i].note ? data[i].note : '-',
          user: user,
        });
      }
    },
    showSetTimeModal: function (type) {
      this.confimType = 'time';
      this.setTimeType = type;
      this.showConfirmDialog800Function();
    },
    showConfirmLastStateModal: function () {
      this.confimType = 'lastState';
      this.showConfirmDialog800Function();
    },
    SetTimeBy800: function () {
      if (this.setTimeType == 'moveFromStation') {
        this.setMoveFromStationTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'arriveToLocation') {
        this.setArriveToLocationTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'moveFromLocation') {
        this.setMoveFromLocationTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'arriveToHospital') {
        this.setArriveToHospitalTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'finish') {
        this.setFinishTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'patientDelivery') {
        this.setPatientDeliveryTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'arriveToStation') {
        this.setArriveToStationTimeFunction(this.missionPhoneId);
      }
    },
    //note tab
    readyNoteData: function (data) {
      this.noteList = [];
      for (let i = 0; i < data.length; i++) {
        let user = '';
        let date = '';
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        if (data[i].noteDate) {
          date = Vue.moment(data[i].noteDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        this.noteList.push({
          user: user,
          date: date,
          note: data[i].note ? data[i].note : '-',
          id: data[i].id,
        });
      }
    },
    noteHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.addNote();
      }
    },
    addNote: function () {
      this.disabelNoteConfirm = true;
      if (!this.noteText) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      if (!this.noteText.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      this.addNoteToMissionFucntion(this.noteText, this.missionId, this.missionPhoneId);
    },
    //address
    readyAddressLogData: function (data) {
      this.addressDataTableHeader = [
        { text: 'آدرس', value: 'address', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.addressDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.addressDataTableItems.push({
          date: date,
          address: data[i].address ? data[i].address : '-',
          user: user,
        });
      }
    },
    //other organ
    /*readyOtherOrganization: function (data) {
            this.otherOrganDataTableHeader = [
                { text: "عنوان", value: "title", align: "center", sortable: false, },
                { text: "تاریخ", value: "date", align: "center", sortable: false, },
            ];
            this.otherOrganDataTableItems = [];
            for (let i = 0; i < data.length; i++) {
                let date = "-";
                if (data[i].requestDate) {
                    date = Vue.moment(data[i].requestDate).format("HH:mm:ss - jYYYY/jM/jD");
                }
                this.otherOrganDataTableItems.push(
                    { title: (data[i].organization) ? data[i].organization : "-", date: date }
                )
            }
        },*/
    addSeletctedOtherOrgan: function () {
      if (!this.selectedOtherOrgan) {
        this.snackText = 'لطفا سازمان همکار را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      for (let i = 0; i < this.allMissionOtherOrganizationInforms.length; i++) {
        if (this.allMissionOtherOrganizationInforms[i].id == this.selectedOtherOrgan) {
          this.snackText = 'سازمان همکار قبلا اضافه شده است';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
      let data = {
        missionId: Number(this.missionId),
        otherOrganizationId: Number(this.selectedOtherOrgan),
      };
      this.addMissionOtherOrganizationInformsFunction(data);
    },
    callToOtherOrgan: function (number) {
      if (number) {
        let data = {
          missionId: this.missionId,
          missionPhoneId: this.missionPhoneId,
          to: number,
        };
        this.callToOtherOrganizationFunction(data);
      }
    },
    //admission
    readyAdmissionData: function (data) {
      this.admissionDataTableHeader = [
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          sortable: false,
        },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.admissionDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.admissionDataTableItems.push({
          hospital: data[i].hospital ? data[i].hospital.title : '-',
          date: date,
          user: user,
        });
      }
    },

    readyMissionAttachListData: function (data) {
      this.missionAttachDetailDataTableHeader = [

        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'شماره پیگیری', value: 'otherPhoneNumber', align: 'center', sortable: false },
        { text: 'کاربر ایجادکننده', value: 'creationUser', align: 'center', sortable: false },
        { text: 'تشخیص پرستار', value: 'diagnosisTitle', align: 'center', sortable: false },
        { text: 'شماره تماس', value: 'callerId', align: 'center', sortable: false },
        { text: 'شکایت اصلی', value: 'chiefComplaintText', align: 'center', sortable: false },
        { text: 'توضیح شکایت', value: 'chiefComplaintNote', align: 'center', sortable: false },
        { text: 'آدرس', value: 'address', align: 'center', sortable: false },
        { text: 'کاربر خاتمه دهنده', value: 'closeUser', align: 'center', sortable: false },
      ];

      try {
        this.missionAttachDetailDataTableItems = [];
        for (let i = 0; i < data.length; i++) {
          let date = '-';
          let closeUser = '';
          let creationUser = '';
          if (data[i].creationDate) {
            date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
          }
          if (data[i].closeUser) {
            let fName = data[i].closeUser.firstName ? data[i].closeUser.firstName : '-';
            let lName = data[i].closeUser.lastName ? data[i].closeUser.lastName : '-';
            closeUser = fName + ' ' + lName;
          }

          if (data[i].creationUser) {
            let fName = data[i].creationUser.firstName ? data[i].creationUser.firstName : '-';
            let lName = data[i].creationUser.lastName ? data[i].creationUser.lastName : '-';
            creationUser = fName + ' ' + lName;
          }

          this.missionAttachDetailDataTableItems.push({
            id: data[i],
            date: date,
            closeUser: closeUser,
            creationUser: creationUser,
            address: data[i].address ? data[i].address : '-',
            callerId: data[i].callerId ? data[i].callerId : '-',
            otherPhoneNumber: data[i].otherPhoneNumber ? data[i].otherPhoneNumber : '-',
            diagnosisTitle: data[i].diagnosisTitle ? data[i].diagnosisTitle : '-',
            chiefComplaintText: data[i].chiefComplaintText ? data[i].chiefComplaintText : '-',
            chiefComplaintNote: data[i].chiefComplaintNote ? data[i].chiefComplaintNote : '-',
          });
        }
      } catch (error) {
        console.log("A error:", error);
      }
    },
    //doctor
    readyDoctorData: function (data) {
      this.allDoctorOrders = [];
      for (let i = 0; i < data.length; i++) {
        let patient = '';
        if (data[i].patient) {
          let fName = data[i].patient.firstName ? data[i].patient.firstName : '-';
          let lName = data[i].patient.lastName ? data[i].patient.lastName : '-';
          patient = fName + ' ' + lName;
        }
        this.allDoctorOrders.push({
          patient: patient,
          doctorInfoDataTableHeader: [],
          doctorInfoDataTableItems: [],
          doctorDrugDataTableHeader: [],
          doctorDrugDataTableItems: [],
          doctorOrderDataTableHeader: [],
          doctorOrderDataTableItems: [],
        });
        const mainLength = this.allDoctorOrders.length - 1;
        this.allDoctorOrders[mainLength].doctorInfoDataTableHeader = [
          {
            text: 'تشخیص',
            value: 'dignosis',
            align: 'center',
            sortable: false,
          },
          { text: 'نتیجه', value: 'result', align: 'center', sortable: false },
          { text: 'توضیحات', value: 'note', align: 'center', sortable: false },
          { text: 'پزشک', value: 'doctor', align: 'center', sortable: false },
        ];
        this.allDoctorOrders[mainLength].doctorDrugDataTableHeader = [
          { text: 'نام دارو', value: 'drug', align: 'center', sortable: false },
          { text: 'تعداد', value: 'count', align: 'center', sortable: false },
          {
            text: 'نحوه تجویز',
            value: 'useage',
            align: 'center',
            sortable: false,
          },
          {
            text: 'دستور استفاده',
            value: 'standBy',
            align: 'center',
            sortable: false,
          },
        ];
        this.allDoctorOrders[mainLength].doctorOrderDataTableHeader = [
          {
            text: 'اقدامات درمانی',
            value: 'actions',
            align: 'center',
            sortable: false,
          },
        ];
        let doctor = '';
        if (data[i].doctor) {
          let fName = data[i].doctor.firstName ? data[i].doctor.firstName : '-';
          let lName = data[i].doctor.lastName ? data[i].doctor.lastName : '-';
          doctor = fName + ' ' + lName;
        }
        this.allDoctorOrders[mainLength].doctorInfoDataTableItems.push({
          dignosis: data[i].diagnosis ? data[i].diagnosis : '-',
          result: data[i].result ? data[i].result : '-',
          note: data[i].note ? data[i].note : '-',
          doctor: doctor,
        });
        for (let j = 0; j < data[i].patientDoctorOrders.length; j++) {
          let standBy = 'استفاده شود';
          if (data[i].patientDoctorOrders[j].isStandby) {
            standBy = 'آماده استفاده';
          }
          this.allDoctorOrders[mainLength].doctorDrugDataTableItems.push({
            drug: data[i].patientDoctorOrders[j].drug
              ? data[i].patientDoctorOrders[j].drug.title
              : '-',
            count: data[i].patientDoctorOrders[j].dosage
              ? data[i].patientDoctorOrders[j].dosage
              : '-',
            useage: data[i].patientDoctorOrders[j].drugOrderType
              ? data[i].patientDoctorOrders[j].drugOrderType.title
              : '-',
            standBy: standBy,
          });
        }
        for (let j = 0; j < data[i].patientDoctorActions.length; j++) {
          this.allDoctorOrders[mainLength].doctorOrderDataTableItems.push({
            actions: data[i].patientDoctorActions[j] ? data[i].patientDoctorActions[j].title : '-',
          });
        }
      }
    },
    clearSetIntrvals: function () {
      clearInterval(this.mapSingleMovingIconInterval);
    },
    showLine: function () {
      if (this.missionPhoneId) {
        this.getMissionPhoneLocationsFunction(this.missionPhoneId);
      }
    },
    toRadians(degrees) {
      return (degrees * Math.PI) / 180;
    },

    // Converts from radians to degrees.
    toDegrees(radians) {
      return (radians * 180) / Math.PI;
    },
    bearing(startLat, startLng, destLat, destLng) {
      startLat = this.toRadians(startLat);
      startLng = this.toRadians(startLng);
      destLat = this.toRadians(destLat);
      destLng = this.toRadians(destLng);
      const y = Math.sin(destLng - startLng) * Math.cos(destLat);
      const x =
        Math.cos(startLat) * Math.sin(destLat) -
        Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
      let brng = Math.atan2(y, x);
      brng = this.toDegrees(brng);
      return (brng + 360) % 360;
    },
    setStoppedPositionState: function (speed, state) {
      if (speed < 2 && !state) {
        return {
          state: 'در حال توقف',
        };
      } else if (speed === 0 && !state) {
        return {
          state: 'توقف',
        };
      }
      return {
        state,
      };
    },
    loadPath: function (data) {
      if (data.length) {
        this.pathsList = [...data]?.map((eachLocation, index) => {
          if (index > 0) {
            delete eachLocation['angle'];
            const preLat = data[index - 1]?.latitude;
            const preLng = data[index - 1]?.longitude;
            return {
              ...eachLocation,
              bearing: this.bearing(preLat, preLng, eachLocation.latitude, eachLocation.longitude),
            };
          }
          return {
            ...eachLocation,
            ...this.setStoppedPositionState(eachLocation?.speed, eachLocation?.state),
          };
        });
      }
      const latLngsList = [...this.pathsList].map(({ latitude, longitude }) => {
        return [latitude, longitude];
      });
      this.latLngsPathList = latLngsList;
      this.ShowAntPath(latLngsList);
    },
    callToPatient: function (number) {
      if (number) {
        let data = {
          missionId: this.missionId,
          missionPhoneId: this.missionPhoneId,
          to: number,
        };
        this.callToPatientFunction(data);
      }
    },
  },
};
